/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Catalog,
  CellEditsIn,
  CellsSaved,
  ExportIn,
  HTTPValidationError,
  JobOut,
  QueryResult,
  RunIn,
  SaveIn,
  SavedQuery
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getQueryCatalogUrl = () => {




  return `/api/v1/query/catalog`
}

/**
 * @summary The queryable tables and fields (labels, types, descriptions) and the operators per type
 */
export const queryCatalog = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Catalog> => {

  return apiFetch<Catalog>(getQueryCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getQueryCatalogQueryKey = () => {
    return [
    `/api/v1/query/catalog`
    ] as const;
    }


export const getQueryCatalogQueryOptions = <TData = Awaited<ReturnType<typeof queryCatalog>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueryCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof queryCatalog>>> = ({ signal }) => queryCatalog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queryCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QueryCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof queryCatalog>>>
export type QueryCatalogQueryError = unknown


export function useQueryCatalog<TData = Awaited<ReturnType<typeof queryCatalog>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryCatalog>>,
          TError,
          Awaited<ReturnType<typeof queryCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueryCatalog<TData = Awaited<ReturnType<typeof queryCatalog>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryCatalog>>,
          TError,
          Awaited<ReturnType<typeof queryCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQueryCatalog<TData = Awaited<ReturnType<typeof queryCatalog>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The queryable tables and fields (labels, types, descriptions) and the operators per type
 */

export function useQueryCatalog<TData = Awaited<ReturnType<typeof queryCatalog>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof queryCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQueryCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getQuerySaveCellsUrl = () => {




  return `/api/v1/query/cells`
}

/**
 * @summary Correct cells of a query result (compare-and-set like the trial grid; one undoable operation)
 */
export const querySaveCells = async (cellEditsIn: CellEditsIn, options?: Parameters<typeof apiFetch>[1]): Promise<CellsSaved> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CellsSaved>(getQuerySaveCellsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cellEditsIn)
  }
);}





export const getQuerySaveCellsMutationKey = () => ['querySaveCells'] as const;

export const getQuerySaveCellsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof querySaveCells>>, TError,QuerySaveCellsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof querySaveCells>>, TError,QuerySaveCellsMutationVariables, TContext> => {

const mutationKey = getQuerySaveCellsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof querySaveCells>>, QuerySaveCellsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  querySaveCells(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuerySaveCellsMutationResult = NonNullable<Awaited<ReturnType<typeof querySaveCells>>>
    export type QuerySaveCellsMutationBody = CellEditsIn
    export type QuerySaveCellsMutationError = HTTPValidationError
    export type QuerySaveCellsMutationVariables = {data: CellEditsIn}

    /**
 * @summary Correct cells of a query result (compare-and-set like the trial grid; one undoable operation)
 */
export const useQuerySaveCells = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof querySaveCells>>, TError,QuerySaveCellsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof querySaveCells>>,
        TError,
        QuerySaveCellsMutationVariables,
        TContext
      > => {
      return useMutation(getQuerySaveCellsMutationOptions(options), queryClient);
    }
    export const getQueryExportUrl = () => {




  return `/api/v1/query/export`
}

/**
 * @summary Export the whole result as .xlsx (a background job)
 */
export const queryExport = async (exportIn: ExportIn, options?: Parameters<typeof apiFetch>[1]): Promise<JobOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<JobOut>(getQueryExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(exportIn)
  }
);}





export const getQueryExportMutationKey = () => ['queryExport'] as const;

export const getQueryExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryExport>>, TError,QueryExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryExport>>, TError,QueryExportMutationVariables, TContext> => {

const mutationKey = getQueryExportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryExport>>, QueryExportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  queryExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryExportMutationResult = NonNullable<Awaited<ReturnType<typeof queryExport>>>
    export type QueryExportMutationBody = ExportIn
    export type QueryExportMutationError = HTTPValidationError
    export type QueryExportMutationVariables = {data: ExportIn}

    /**
 * @summary Export the whole result as .xlsx (a background job)
 */
export const useQueryExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryExport>>, TError,QueryExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryExport>>,
        TError,
        QueryExportMutationVariables,
        TContext
      > => {
      return useMutation(getQueryExportMutationOptions(options), queryClient);
    }
    export const getQueryRunUrl = () => {




  return `/api/v1/query/run`
}

/**
 * @summary Run a query (preview: at most 1000 rows, with the total count and the join path)
 */
export const queryRun = async (runIn: RunIn, options?: Parameters<typeof apiFetch>[1]): Promise<QueryResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<QueryResult>(getQueryRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(runIn)
  }
);}





export const getQueryRunMutationKey = () => ['queryRun'] as const;

export const getQueryRunMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryRun>>, TError,QueryRunMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryRun>>, TError,QueryRunMutationVariables, TContext> => {

const mutationKey = getQueryRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryRun>>, QueryRunMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  queryRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryRunMutationResult = NonNullable<Awaited<ReturnType<typeof queryRun>>>
    export type QueryRunMutationBody = RunIn
    export type QueryRunMutationError = HTTPValidationError
    export type QueryRunMutationVariables = {data: RunIn}

    /**
 * @summary Run a query (preview: at most 1000 rows, with the total count and the join path)
 */
export const useQueryRun = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryRun>>, TError,QueryRunMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryRun>>,
        TError,
        QueryRunMutationVariables,
        TContext
      > => {
      return useMutation(getQueryRunMutationOptions(options), queryClient);
    }
    export const getQuerySavedUrl = () => {




  return `/api/v1/query/saved`
}

/**
 * @summary Own and shared saved queries
 */
export const querySaved = async ( options?: Parameters<typeof apiFetch>[1]): Promise<SavedQuery[]> => {

  return apiFetch<SavedQuery[]>(getQuerySavedUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getQuerySavedQueryKey = () => {
    return [
    `/api/v1/query/saved`
    ] as const;
    }


export const getQuerySavedQueryOptions = <TData = Awaited<ReturnType<typeof querySaved>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof querySaved>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuerySavedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof querySaved>>> = ({ signal }) => querySaved({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof querySaved>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QuerySavedQueryResult = NonNullable<Awaited<ReturnType<typeof querySaved>>>
export type QuerySavedQueryError = unknown


export function useQuerySaved<TData = Awaited<ReturnType<typeof querySaved>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof querySaved>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof querySaved>>,
          TError,
          Awaited<ReturnType<typeof querySaved>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQuerySaved<TData = Awaited<ReturnType<typeof querySaved>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof querySaved>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof querySaved>>,
          TError,
          Awaited<ReturnType<typeof querySaved>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQuerySaved<TData = Awaited<ReturnType<typeof querySaved>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof querySaved>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Own and shared saved queries
 */

export function useQuerySaved<TData = Awaited<ReturnType<typeof querySaved>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof querySaved>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQuerySavedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getQueryCreateSavedUrl = () => {




  return `/api/v1/query/saved`
}

/**
 * @summary Save a new query
 */
export const queryCreateSaved = async (saveIn: SaveIn, options?: Parameters<typeof apiFetch>[1]): Promise<SavedQuery> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<SavedQuery>(getQueryCreateSavedUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveIn)
  }
);}





export const getQueryCreateSavedMutationKey = () => ['queryCreateSaved'] as const;

export const getQueryCreateSavedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryCreateSaved>>, TError,QueryCreateSavedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryCreateSaved>>, TError,QueryCreateSavedMutationVariables, TContext> => {

const mutationKey = getQueryCreateSavedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryCreateSaved>>, QueryCreateSavedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  queryCreateSaved(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryCreateSavedMutationResult = NonNullable<Awaited<ReturnType<typeof queryCreateSaved>>>
    export type QueryCreateSavedMutationBody = SaveIn
    export type QueryCreateSavedMutationError = HTTPValidationError
    export type QueryCreateSavedMutationVariables = {data: SaveIn}

    /**
 * @summary Save a new query
 */
export const useQueryCreateSaved = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryCreateSaved>>, TError,QueryCreateSavedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryCreateSaved>>,
        TError,
        QueryCreateSavedMutationVariables,
        TContext
      > => {
      return useMutation(getQueryCreateSavedMutationOptions(options), queryClient);
    }
    export const getQueryDeleteSavedUrl = (queryId: number,) => {




  return `/api/v1/query/saved/${queryId}`
}

/**
 * @summary Delete an own saved query
 */
export const queryDeleteSaved = async (queryId: number, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getQueryDeleteSavedUrl(queryId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getQueryDeleteSavedMutationKey = () => ['queryDeleteSaved'] as const;

export const getQueryDeleteSavedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryDeleteSaved>>, TError,QueryDeleteSavedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryDeleteSaved>>, TError,QueryDeleteSavedMutationVariables, TContext> => {

const mutationKey = getQueryDeleteSavedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryDeleteSaved>>, QueryDeleteSavedMutationVariables> = (props) => {
          const {queryId} = props ?? {};

          return  queryDeleteSaved(queryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryDeleteSavedMutationResult = NonNullable<Awaited<ReturnType<typeof queryDeleteSaved>>>

    export type QueryDeleteSavedMutationError = HTTPValidationError
    export type QueryDeleteSavedMutationVariables = {queryId: number}

    /**
 * @summary Delete an own saved query
 */
export const useQueryDeleteSaved = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryDeleteSaved>>, TError,QueryDeleteSavedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryDeleteSaved>>,
        TError,
        QueryDeleteSavedMutationVariables,
        TContext
      > => {
      return useMutation(getQueryDeleteSavedMutationOptions(options), queryClient);
    }
    export const getQueryUpdateSavedUrl = (queryId: number,) => {




  return `/api/v1/query/saved/${queryId}`
}

/**
 * @summary Change an own saved query
 */
export const queryUpdateSaved = async (queryId: number,
    saveIn: SaveIn, options?: Parameters<typeof apiFetch>[1]): Promise<SavedQuery> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<SavedQuery>(getQueryUpdateSavedUrl(queryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveIn)
  }
);}





export const getQueryUpdateSavedMutationKey = () => ['queryUpdateSaved'] as const;

export const getQueryUpdateSavedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryUpdateSaved>>, TError,QueryUpdateSavedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryUpdateSaved>>, TError,QueryUpdateSavedMutationVariables, TContext> => {

const mutationKey = getQueryUpdateSavedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryUpdateSaved>>, QueryUpdateSavedMutationVariables> = (props) => {
          const {queryId,data} = props ?? {};

          return  queryUpdateSaved(queryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryUpdateSavedMutationResult = NonNullable<Awaited<ReturnType<typeof queryUpdateSaved>>>
    export type QueryUpdateSavedMutationBody = SaveIn
    export type QueryUpdateSavedMutationError = HTTPValidationError
    export type QueryUpdateSavedMutationVariables = {queryId: number;data: SaveIn}

    /**
 * @summary Change an own saved query
 */
export const useQueryUpdateSaved = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryUpdateSaved>>, TError,QueryUpdateSavedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryUpdateSaved>>,
        TError,
        QueryUpdateSavedMutationVariables,
        TContext
      > => {
      return useMutation(getQueryUpdateSavedMutationOptions(options), queryClient);
    }
